import ShowMoreButton from './ShowMoreButton';

const SELECTOR = '[data-truncate-list], [data-truncate-location-list]';
const LIMIT = 10;

class TruncateList {
  constructor() {
    if ($(SELECTOR).size()) {
      this.initialize();
    }
  }

  initialize() {
    $(SELECTOR).each((index, element) => {
      const $list = $(element);
      const limit = $list.data('limit') ? $list.data('limit') : LIMIT;
      const remainingItems = $list.children('li').size() - limit;

      if (remainingItems > 0) {
        new ShowMoreButton($list, remainingItems);
      }
    });
  }
}

export default TruncateList;



// WEBPACK FOOTER //
// ./src/javascripts/TruncateList/TruncateList.js